export const ISO_STRING_FORMAT = `yyyy-MM-dd'T'HH:mm:ss'Z'`

export const LONDON_TIMEZONE = 'Europe/London'

export const DATE_FORMAT_WITH_SLASHES = 'DD/MM/YYYY'

export const ISO_DATE_REGEX_PATTERN = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(\.\d+)?Z$/
